module.exports = __webpack_public_path__ + "static/uswithcop-204c6a8a92778fce7370b199ec7b87cc.jpg";